import * as RadixModal from "@radix-ui/react-dialog";
import { styled } from "@vitality-ds/system";
import BaseModalOverlayStyles from "./styles/BaseModalBlanket.styles";
import BaseModalContentStyles from "./styles/BaseModalContent.styles";
export var BaseModalBlanket = styled(RadixModal.Overlay, BaseModalOverlayStyles);
export var BaseModalContent = styled(RadixModal.Content, BaseModalContentStyles);